<div id="footerRegBlock" class="footerRegBlock" *ngIf="!isUserLoggedIn">
  <div class="registerCard">
      <div class="heading"><h3>{{'footercreateaccountblockComp.footercreateaccountblock1' | translate}}</h3></div>
      <div *ngIf="isCountryAllowed === 2" class="hc_btnright"><button class="site-btn site-btn__primary site-btn--lg" (click)="goToregStep1()">{{'footercreateaccountblockComp.footercreateaccountblock2' | translate}}</button></div>
      <div *ngIf="isCountryAllowed === 1" class="hc_btnright"><button class="site-btn site-btn__primary site-btn--lg" (click)="goToTrustlyReg()">{{'payandplay.depositnow' | translate}}</button></div>
  </div>
  <ul class="fetureslist hidden-xs hidden-sm">
      <li>{{'footercreateaccountblockComp.footercreateaccountblock3' | translate}}</li>
      <li><span class="list-dots"></span> {{'footercreateaccountblockComp.footercreateaccountblock4' | translate}}</li>
      <li><span class="list-dots"></span> {{'footercreateaccountblockComp.footercreateaccountblock5' | translate}}</li>
  </ul>
</div>
<div id="footerRegBlock" class="footerRegBlock" *ngIf="isUserLoggedIn">
  <div class="registerCard">
      <div class="heading"><h3>{{'footercreateaccountblockComp.footercreateaccountblock6' | translate}}</h3></div>
      <div class="hc_btnright"><button class="site-btn site-btn__primary site-btn--lg" (click)="goToPromotion()">{{'footercreateaccountblockComp.footercreateaccountblock7' | translate}}</button></div>
  </div>
  <ul class="fetureslist hidden-xs hidden-sm">
      <li> {{'footercreateaccountblockComp.footercreateaccountblock8' | translate}}</li>
      <li><span class="list-dots"></span> {{'footercreateaccountblockComp.footercreateaccountblock9' | translate}}</li>
      <li><span class="list-dots"></span> {{'footercreateaccountblockComp.footercreateaccountblock10' | translate}}</li>
  </ul>
</div>
